import { render } from "./Privacies.vue?vue&type=template&id=02e39af0"
import script from "./Privacies.vue?vue&type=script&lang=js"
export * from "./Privacies.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__